import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) {
    // Never include session tokens, form values or resident records in client error logs.
    console.error('Workspace rendering failed:', error.name);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main role="alert" className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <section className="max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center">
        <h1 className="text-2xl font-semibold text-slate-900">Unable to display this page</h1>
        <p className="my-4 text-slate-600">Please reload the page. Your saved workspace data is unchanged.</p>
        <button type="button" className="rounded-lg bg-blue-600 px-5 py-3 text-white" onClick={() => window.location.reload()}>Reload page</button>
      </section>
    </main>;
  }
}
